import { Body, Button } from '@e2n/ui/v2';
import { CreateVorlageAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateVorlageAbschnitt/CreateVorlageAbschnitt';
import { VorlageAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/VorlageDetails/VorlageAbschnitt';
import { VorlageHeader } from '@/domain/mitarbeiter/features/rotationsplan/features/VorlageDetails/VorlageHeader';
import { useRotationsplanVorlageById } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import {
  faArrowLeft,
  faEllipsisVertical,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

const noop = () => {};

export function VorlageDetails() {
  const { vorlageId } = useParams();
  const { t } = useTranslation();
  const { vorlage } = useRotationsplanVorlageById(vorlageId ?? '');

  return (
    <div className="flex flex-col gap-8 w-full min-w-0">
      <div className="flex flex-col gap-5 w-full min-w-0">
        <div className="flex justify-between items-start">
          <div className="flex gap-2 items-center">
            <Button asChild iconOnly variant="ghost-on-grey">
              <Link to="/mitarbeiter/rotationsplaene/vorlagen">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
            </Button>
            <Body weight="semibold">
              {t('domain.mitarbeiter.rotationsplan.tabs.vorlagen')}
            </Body>
          </div>
          {vorlage && (
            <Button
              aria-label={t(
                'domain.mitarbeiter.rotationsplan.vorlagen.mehrOptionen',
              )}
              iconOnly
              type="button"
              variant="ghost-on-grey"
              onClick={noop}>
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </Button>
          )}
        </div>
        {vorlage && <VorlageHeader vorlage={vorlage} />}
      </div>

      {!vorlage ? (
        <Body className="text-labels-secondary">
          {t('domain.mitarbeiter.rotationsplan.vorlagen.details.notFound')}
        </Body>
      ) : (
        <div className="flex flex-col gap-5 w-full min-w-0">
          {vorlage.abschnitte.map((abschnitt) => (
            <VorlageAbschnitt
              key={abschnitt.id}
              vorlageId={vorlage.id}
              abschnitt={abschnitt}
            />
          ))}
          <CreateVorlageAbschnitt vorlage={vorlage} />
        </div>
      )}
    </div>
  );
}
